var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 45,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CE0000",
    fillRule: "evenodd",
    d: "M30 0h30v45H30V0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 0h30v45H0V0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1EEEE",
    fillRule: "evenodd",
    d: "M14.5 13.3c0 .1 0 .2-.3.2-.1 0-.3 0-.3-.2l.3-.2c.2 0 .3 0 .3.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C00",
    fillRule: "evenodd",
    d: "M5 12.2v5.6h5.5c0 1 1 1.9 1.9 1.9v5.6H18v-5.6c1 0 1.8-1 1.8-1.9h5.6v-5.6h-5.6c0-.9-1-1.8-1.8-1.8V4.8h-5.6v5.6c-1 0-1.9 1-1.9 1.8H5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE600",
    fillRule: "evenodd",
    d: "M5.1 12.4v5.2h5.6c0 1 1 1.9 1.9 1.9v5.6h5.2v-5.6c.9 0 1.8-1 1.8-1.8h5.6v-5.3h-5.6a2 2 0 0 0-1.8-1.8V5h-5.2v5.6a2 2 0 0 0-1.9 1.8H5.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    fillRule: "evenodd",
    d: "M5.3 12.6v4.8H11c0 1 1 2 1.8 2v5.5h4.9v-5.6c1 0 1.8-1 1.8-1.9H25v-4.8h-5.6c0-1-.9-1.8-1.8-1.8V5.2h-4.9v5.6a2 2 0 0 0-1.8 1.8H5.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0A0A0",
    fillRule: "evenodd",
    d: "M5.5 12.8v4.5h5.6c0 .9 1 1.8 1.8 1.8v5.6h4.5V19c1 0 1.9-1 1.9-1.8h5.5v-4.5h-5.5c0-1-1-1.9-2-1.9V5.4H13v5.5a2 2 0 0 0-1.8 1.9H5.5Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0D0D0",
    fillRule: "evenodd",
    d: "M13 10.5c.3.3 0 1.1-.6 1.8-.7.6-1.5.9-1.8.6-.3-.4 0-1.2.6-1.8.7-.7 1.5-1 1.8-.6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    d: "M12.6 10.9c.3.3.2 1-.2 1.4-.4.4-1 .5-1.4.2-.3-.4-.2-1 .2-1.4a1 1 0 0 1 1.4-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0D0D0",
    fillRule: "evenodd",
    d: "M11 11.9v-.2l.6.3-.3-.5.2-.2.5 1-1-.4Zm.7-.8.2-.2.8.8-.2.2-.8-.8Zm8 1.7c-.3.4-1.1.1-1.8-.6-.6-.6-.9-1.4-.6-1.7.4-.3 1.2 0 1.8.6.7.6 1 1.4.6 1.7Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    d: "M19.3 12.5c-.3.3-1 .2-1.4-.2-.4-.5-.5-1-.2-1.4a1 1 0 0 1 1.4.2c.5.4.6 1 .2 1.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0D0D0",
    fillRule: "evenodd",
    d: "m18.3 10.8.2.1-.3.6.5-.3.2.2-1 .5.4-1Zm.8.8.2.1-.8.8-.2-.1.8-.8Zm-1.8 8c-.3-.3 0-1.1.6-1.8.7-.7 1.5-.9 1.8-.6.3.3 0 1.1-.6 1.8s-1.4 1-1.8.6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    d: "M17.8 19.2c-.4-.3-.3-1 .1-1.4.5-.4 1.1-.5 1.4-.2.4.3.3 1-.2 1.4-.4.4-1 .5-1.4.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0D0D0",
    fillRule: "evenodd",
    d: "m19.4 18.2-.1.1-.6-.2.3.5-.1.1-.6-1 1 .5Zm-.8.8-.1.1-.8-.8.1-.1.8.8Zm-8-1.8c.3-.3 1.1 0 1.8.6.6.7.9 1.5.6 1.8-.3.3-1.1 0-1.8-.6-.7-.7-.9-1.5-.6-1.8Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    d: "M11 17.6c.3-.3 1-.2 1.4.2.4.4.5 1 .2 1.4-.3.3-1 .2-1.4-.2-.4-.4-.5-1-.2-1.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0D0D0",
    fillRule: "evenodd",
    d: "m12 19.3-.1-.2.2-.5-.5.3-.1-.2 1-.5-.5 1Zm-.8-.8-.1-.2.8-.7h.1l-.8.9Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    fillRule: "evenodd",
    d: "M15.2 11.2A3.9 3.9 0 1 0 19 15a4 4 0 0 0-4-3.8Zm4 3.9Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    fillRule: "evenodd",
    d: "M15.2 12a3 3 0 1 0 3 3 3 3 0 0 0-3-3Zm3 3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0D0D0",
    fillRule: "evenodd",
    d: "M13.9 18.2a.2.2 0 1 1-.4 0 .2.2 0 0 1 .4 0Zm3 0a.2.2 0 1 1-.4 0 .2.2 0 0 1 .3 0Zm-1.9 0v.2h-.2c-.3 0-.3.2 0 .2h.2v.2c0 .2.3.2.3 0v-.2h.2c.3 0 .3-.2 0-.2h-.2v-.2c0-.2-.3-.2-.3 0Zm-.8-2.8v.2h-.4c-.4.1-.4 0-.4 0v1h-.1v-.4l-.2-.6 1.1-.2Zm1.5-.3h1l.1.4c0 .1 0 .3-.1.2v-.6l-.7.1c-.4 0-.2-.1-.3-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    fillRule: "evenodd",
    d: "M16.7 15a1.8 1.8 0 0 1 .1.4v.3h-.1v-.5a1 1 0 0 1-.3 0 2 2 0 0 1-.4 0h-.3V15h1Zm-1 0h1a2.5 2.5 0 0 1 .1.4v.3h-.1v-.5a1 1 0 0 1-.3 0 2 2 0 0 1-.4 0h-.2V15Zm-2.5.6v.4l.1.2v.5a.8.8 0 0 0 .1-.2v-.8a2.7 2.7 0 0 0 .8-.1v-.2a16 16 0 0 0-1 .2Zm1-.2a16 16 0 0 0-1 .2v.4l.1.2v.5a1.1 1.1 0 0 0 .1-.2v-.8a2.7 2.7 0 0 0 .8 0 .3.3 0 0 0 0-.1v-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0D0D0",
    fillRule: "evenodd",
    d: "M15.8 15.3h.6l.2.5c0 .2 0 .3-.2.2v-.5h-1l-.6.1-1-.1-.4.1H13v1h-.1v-.4c0-.3-.2-.6-.1-.7h.3c0-.1-.2-.4-.1-.8 0-.3.3-.2.7-.2H15c.2 0 .1-.5.3-.8a.6.6 0 0 1 .5-.2l.3.6H16c-.2.1-.2 0-.3-.1l.2 1c0 .2-.2.4-.2.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    fillRule: "evenodd",
    d: "M15.9 13.5a.6.6 0 0 0-.5.3l-.1.3v.3l-.2.1h-1.6a7.2 7.2 0 0 0-.3 0H13v.7l.1.2h-.3v.4l.1.2v.3a3 3 0 0 1 0 .2h.1a1.7 1.7 0 0 0 0-.4v-.5h.8a.3.3 0 0 0 0-.1 1 1 0 0 0 .3 0l.7.1h.5v-.1h.4a1.9 1.9 0 0 0 .7 0l.1.3v.2-.3a1.5 1.5 0 0 0 0-.3.5.5 0 0 0-.1 0 2.4 2.4 0 0 0-.6 0v-.1l.1-.3v-.6a6 6 0 0 1 0-.4v.1h.2v-.2a1.5 1.5 0 0 0-.1-.3h-.1Zm0 1.8a3.3 3.3 0 0 1 .5 0 2.8 2.8 0 0 1 .2.4v.3h-.1v-.4a1 1 0 0 0-.1-.1 1 1 0 0 1-.2 0h-.5a4 4 0 0 1-.3 0h-.1l-.5.1a3.1 3.1 0 0 1-1 0H13v.5a1.7 1.7 0 0 1 0 .5v-.8a2 2 0 0 1-.2-.2v-.1h.2a1.2 1.2 0 0 0 .1 0v-.4l-.2-.5.1-.1.2-.1h.8a14.6 14.6 0 0 0 1 0l.2-.1v-.2l.2-.5a.6.6 0 0 1 .5-.2h.1l.1.3a1.5 1.5 0 0 1 .1.3h-.3v1.3Zm.5 0Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0D0D0",
    fillRule: "evenodd",
    d: "m14.6 14.9-.5.4.1.2-.3-.3.5-.3c0-.1-.4-.2-.4-.4l-.1-.7-.6-.3c0-.2.6-.5.6-.6 0 0 .1 0 0 .1l-.4.5.5.1.2-.1s-.2 0-.2-.2l.2-.2.2.2-.1.2.2.1.6.4h.1v.1H15l-.6-.3v.8s.2 0 .1.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    fillRule: "evenodd",
    d: "M14 13h-.1c-.2 0-.2.1-.3.2a2 2 0 0 0-.3.2v.1l.3.1.2.1h.1v.8l.3.2a1.4 1.4 0 0 1 .2.1v.1l-.2.2a3.1 3.1 0 0 1-.3 0l.2.5h.1v-.4a4.5 4.5 0 0 1 .4-.3v-.5a4.9 4.9 0 0 1 0-.7 1.4 1.4 0 0 1 .5.2.2.2 0 0 0 0 .2l.1-.1a2.7 2.7 0 0 0-.6-.4h-.4v-.2h.1v-.2H14v.4a1.7 1.7 0 0 1-.4 0l-.1-.1v-.1a4.2 4.2 0 0 1 .3-.3h.2v-.2Zm.7 1.9h-.1a2 2 0 0 1-.2.2 4.8 4.8 0 0 0-.3.2v.1h.1v.1l-.3-.3a2.2 2.2 0 0 1 .1 0 3.2 3.2 0 0 0 .3-.2v-.2h-.1l-.2-.3a2 2 0 0 1 0-.4v-.2a.8.8 0 0 0-.1-.1h-.1l-.2-.1-.2-.1-.1-.1v-.2l.3-.1.2-.2a5.8 5.8 0 0 0 .2-.1v.1l-.1.1a15.7 15.7 0 0 0-.4.4h.6v-.4h.2l.1.1v.1h-.1v.1h.2v.1h.2l.2.2.2.2h.1v.1m-.7-.3v.1a3.3 3.3 0 0 0 0 .6v.2h.1v.2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7A7A7",
    fillRule: "evenodd",
    d: "M13.9 13.6h.7v.7H14v-.7Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "m16.3 16.3-2.5-3.7 2.4 3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0D0D0",
    fillRule: "evenodd",
    d: "M14 13h-.1v-.1h.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    fillRule: "evenodd",
    d: "M14 12.9h-.1v.2h.1v-.2Zm-.2 0h.2v.2h-.2v-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    d: "M16.2 14H15h1.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A7A7A7",
    fillRule: "evenodd",
    d: "M14 14.3h.5v.3H14v-.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    d: "m16 13.8-.2.2v-.2l.2-.2v.2Zm0 .3.2-.1h-.1v.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    d: "M16 14v.1-.1l-.1-.2.1.2Zm0 .4h-1 .9Zm-1.5 0H14h.6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0D0D0",
    fillRule: "evenodd",
    d: "M13.2 16.3s.1.2.5.2c.5 0 .6 0 .4-.2h-.4c0 .2-.1.2-.2.1 0 0-.2-.3.1-.3h1c.2.2-.1.4 0 .4h1.5v-.3l-.4-.1-.2-.1c0-.1.2 0 .2 0v-.1h-.1v-.1h.7v.2s.3.3.2.5c0 .2-.3.2-.3.3l.8.1.3.2h-.8c-.4 0-.5-.2-.7-.2h-1l-.7.2h-.3l.2-.1.4-.2v-.4s.2-.1.1-.2h-.9v.2-.1h.6s.1.2 0 .2a1.2 1.2 0 0 1-.9 0l-.1-.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    fillRule: "evenodd",
    d: "M15.6 15.8v.1h.1m-.1 0v-.1h.7v.2a3.7 3.7 0 0 1 .1.2l.1.3-.2.2-.1.1.3.1h.2a13.1 13.1 0 0 1 .3 0l.3.2H17m-1-1.3h-.4m-2 .4v.1l.3-.1m-.3 0h.1a3.4 3.4 0 0 1 .7 0h.1v.2l-.1.4-.1.1H14l-.2.2m.4-.8v.2a1.2 1.2 0 0 1-.9 0v-.1a.4.4 0 0 1-.1-.1m1 0Zm0 0Zm0 0-.3-.1h.2Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M16 16h-.1v-.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0D0D0",
    d: "M18.2 15.2h.3l.4-.2v.1l-.2.2h-.2l.1.2.1.2v.1l-.2-.4h-.3v-.2Zm-.4-1.8.5-.2-.1-.2.3.6-.1-.3-.5.3v-.2Zm-.7-.8.4-.4h.1v.7l.4-.3v.1l-.4.4v-.7l-.4.3v-.1Zm-1.8-.8v-.5h.2l-.1.5h.4v.1h-.5Zm-1 .1v-.5l.2.4h.4l-.6.1Zm-1.6.8.2-.2.2.1-.2.2v.1c-.2 0-.2.1-.3.2h-.2l-.1-.1s-.1-.1 0-.2v-.2l.1-.1.2-.1h.2-.2l-.1.1-.1.1v.4h.2l.3-.2v-.1l-.2.1Zm0 4.2-.5.3-.4-.5.4.4.1-.1-.2-.4.3.4.2-.2v.1Zm-.8-.8h.2v-.3l-.1-.2h-.3v.5h.2Zm0 .2a.3.3 0 0 1-.2 0l-.1-.4v-.4a.2.2 0 0 1 .3 0h.1l.2.5-.1.2H12ZM12 15h-.6v-.5l.1-.1a.1.1 0 0 1 .1 0h.1v.2l.2-.1.1-.2v.2l-.2.1v.4h.2v.1Zm-.3-.1v-.5h-.2v.5h.2Zm1.6-2.6v-.6l.1-.1.6.3h-.3l-.3.2v.2h-.1Zm.1-.3.3-.2h-.2l-.1-.1v.3Zm2.8-.2.6-.3.1.1v.7h-.1V12l-.3-.2h-.3Zm.4 0 .2.2v-.4.1h-.2ZM18 14l.6-.1v.6a.1.1 0 0 1 0 .1h-.1l-.1-.2v.1l-.1.1-.1.2v-.3h.1V14H18Zm.3 0 .1.3v.2h.2V14h-.3Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMt);
export default __webpack_public_path__ + "static/media/mt.a0be4b75e966fc895e41c754590a8f2f.svg";
export { ForwardRef as ReactComponent };